// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNavigationHeader-module--cls1--1CAMn","cls2":"SideNavigationHeader-module--cls2--3i5rG SideNavigationHeader-module--cls1--1CAMn"};